export default "__VITE_ASSET__DJstKL3$__"